@if (isMobile() && remoteConfigService.isInitialized() && remoteConfigService.config().maintenance_mode) {
<ld-maintenance-modal id="maintenance-modal" [message]="remoteConfigService.config().maintenance_message" />
} @if (forceUpdateService.updateRequired() && !remoteConfigService.config().maintenance_mode) { @let result =
forceUpdateService.checkResult();
<ld-force-update-modal
  id="force-update-modal"
  [title]="result?.title || ''"
  [message]="result?.message || ''"
  [currentVersion]="result?.currentVersion || ''"
  [minimumVersion]="result?.minimumVersion || ''"
/>
}

<ld-offline-screen
  id="offline-screen"
  [isOpen]="offlineDetectionService.showOfflineScreen()"
  [isRetrying]="offlineDetectionService.isRetrying()"
  (retryClicked)="offlineDetectionService.retry()"
  (dismissClicked)="offlineDetectionService.dismiss()"
/>

<router-outlet id="router-outlet"></router-outlet>

@if (showChatCard()) {
<ld-chat-card
  id="app-chat-card"
  [isMobile]="isMobile()"
  [isLoading]="servisBotService.isLoading()"
  (chatClick)="onChatClick()"
/>
}

<ld-toast-container id="toast-container"></ld-toast-container>

@if (userIdleService.isWatching()) {
<ld-session-timeout-modal id="session-timeout-modal"></ld-session-timeout-modal>
}

<ld-chunk-error-dialog
  id="chunk-error-dialog"
  [isOpen]="chunkErrorService.dialogVisible()"
  (refreshClicked)="chunkErrorService.refresh()"
></ld-chunk-error-dialog>

<ld-error-modal
  id="custom-error-modal"
  [isOpen]="customErrorModalService.isOpen()"
  [title]="customErrorModalService.title()"
  [message]="customErrorModalService.message()"
  [icon]="customErrorModalService.icon()"
  [primaryBtnText]="customErrorModalService.primaryBtnText()"
  [secondaryBtnText]="customErrorModalService.secondaryBtnText()"
  (closed)="customErrorModalService.close()"
  (primaryClick)="customErrorModalService.onPrimaryClick()"
  (secondaryClick)="customErrorModalService.onSecondaryClick()"
></ld-error-modal>
